export enum PRODUCT_RECOMMENDATION_STATUS {
  PROMOTED = "AVAILABLE",
  EXCLUDED = "EXCLUDED",
  DEFAULT = "DEFAULT",
}

export enum PRODUCT_RECOMMENDATION_STATUS_NUMBER {
  PROMOTED = 1,
  EXCLUDED = 2,
  DEFAULT = 3,
}
